import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const aiDataInsightsTableColumns: ITableColumn[] = [
  {
    labelPath: 'aiDataInsightsPage.tableColumns.name',
    propertyKey: 'name',
    colType: TableColumnTypeEnum.Text,
    width: 250,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'aiDataInsightsPage.tableColumns.fileUrl',
    propertyKey: 'id',
    colType: TableColumnTypeEnum.Text,
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'aiDataInsightsPage.tableColumns.evidence',
    propertyKey: 'evidence',
    colType: TableColumnTypeEnum.Text,
    width: 300,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'aiDataInsightsPage.tableColumns.findingsCount',
    propertyKey: 'numberOfFindings',
    colType: TableColumnTypeEnum.Text,
    width: 100,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'aiDataInsightsPage.tableColumns.firstDetected',
    propertyKey: 'firstDetectionDate',
    linkPropertyKey: 'firstDetectionUrl',
    colType: TableColumnTypeEnum.LinkNewPage,
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'aiDataInsightsPage.tableColumns.lastDetected',
    propertyKey: 'lastDetectionDate',
    linkPropertyKey: 'lastDetectionUrl',
    colType: TableColumnTypeEnum.LinkNewPage,
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
];
